"use client"

import { usePathname } from "next/navigation"
import { useCartSidebarVisibile } from "src/components/np-design/sections/cart-sidebar/state"
import { routes } from "src/config/routes"
import { IntegrationScript } from "../lib/IntegrationScript"

// https://www.trustedshops.com/tsb2b/sa/shopDashboard.seam
const trustedShopsId = "XB5E73CE370D7E01B02611C1505B9F7E4"

// https://help.etrusted.com/hc/en-gb/articles/360047444811-How-can-I-integrate-the-Trustbadge-in-my-website-without-a-plugin#step-2-configure-the-trustbadge-code
const src = `https://widgets.trustedshops.com/js/${trustedShopsId}.js`

// Circumvents the Next.js Script component's automatic loading and deduplication behavior and skips the consent check.
export const TrustedShopsTagRaw = () => <script id="trustedshops" src={src} async />

export const TrustedShopsTag = () => {
  const cardSidebarVisible = useCartSidebarVisibile()
  const pathname = usePathname()
  const isThankYou = pathname.startsWith(routes.orderComplete)

  if (cardSidebarVisible || isThankYou) {
    return null
  }

  return <IntegrationScript id="trustedshops" src={src} data-desktop-position="left" data-mobile-position="left" />
}
